import type {
  MentorProfileDraft,
  MentorProfileReview,
  MentorProfileReviewStatus,
} from "@/lib/api/mentor-profile";
import type { Profile, User } from "@/lib/api/user";
import { draftsDiffer } from "@/lib/mentor-profile/submit-readiness";

type LiveProfile = Profile & {
  display_name?: string;
  languages?: string[];
  spotify_meta?: Record<string, unknown>;
  spotify_preview_url?: string;
};

const OPEN_DRAFT_STATUSES = new Set<MentorProfileReviewStatus>([
  "in_progress",
  "submitted",
  "in_review",
  "changes_requested",
]);

export function liveProfileDraft(user: User): MentorProfileDraft {
  const profile = user.profile as LiveProfile | undefined;

  return {
    display_name: profile?.display_name || user.first_name || "",
    pronouns: user.pronouns || "",
    languages: profile?.languages ?? [],
    bio: profile?.bio || "",
    favorite_music: profile?.favorite_music || "",
    spotify_meta: profile?.spotify_meta,
    spotify_preview_url: profile?.spotify_preview_url,
    match_card_photo_url: profile?.match_card_photo_url,
    profile_picture_url: user.profile_picture_url || undefined,
    profile_audio_url: profile?.profile_audio_url || undefined,
    interests: profile?.interests ?? [],
    interest_images: profile?.interest_images ?? [],
    vibe_images: profile?.vibe_images ?? [],
  };
}

export function openReviewDraft(
  review:
    | Pick<MentorProfileReview, "status" | "draft" | "published_snapshot">
    | null
    | undefined,
): MentorProfileDraft | null {
  if (!review) return null;
  if (OPEN_DRAFT_STATUSES.has(review.status)) return review.draft;
  if (
    review.status === "approved" &&
    review.published_snapshot &&
    draftsDiffer(review.draft, review.published_snapshot)
  ) {
    return review.draft;
  }
  return null;
}
